import { Link, useLocation } from 'react-router-dom';

const SECTIONS = [
  { id: 'philosophy', label: 'Our Philosophy' },
  { id: 'services', label: 'What We Do' },
  { id: 'contact', label: 'Get in Touch' },
];

function scrollToSection(id: string) {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
}

export default function Navbar() {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-parchment/95 backdrop-blur-sm border-t border-amber/15">
      <div className="flex items-center justify-between px-4 md:px-8 lg:px-12 h-16 md:h-[72px]">
        {/* Logo */}
        <Link
          to="/"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="flex flex-col select-none leading-none"
        >
          <img src="/assets/logo2.png" alt="Logo" className="h-8 md:h-10" />
        </Link>

        {/* Center links */}
        <div className="hidden md:flex items-center gap-1">
          {SECTIONS.map((section, i) => (
            <span key={section.id} className="flex items-center gap-1">
              <button
                onClick={() => {
                  if (!isHome) {
                    window.REACT_APP_NAVIGATE?.('/');
                    setTimeout(() => scrollToSection(section.id), 300);
                  } else {
                    scrollToSection(section.id);
                  }
                }}
                className="font-body text-[10px] uppercase tracking-wide-custom font-medium transition-colors duration-200 whitespace-nowrap py-2 px-2 text-muted-umber hover:text-deep-ink cursor-pointer bg-transparent border-none"
              >
                {section.label}
              </button>
              {i < SECTIONS.length - 1 && (
                <span className="w-[1px] h-2.5 bg-amber/25 mx-1" />
              )}
            </span>
          ))}
        </div>

        {/* CTA */}
        <Link
          to="/natto"
          className="flex items-center gap-2 font-body text-[12px] font-semibold text-deep-ink hover:text-amber transition-colors duration-200 whitespace-nowrap select-none cursor-pointer"
        >
          <span>The food behind our name</span>
          <span className="w-6 h-6 flex items-center justify-center">
            <i className="ri-arrow-right-line text-lg" />
          </span>
        </Link>
      </div>
    </nav>
  );
}